import { render, staticRenderFns } from "./ViSchoolList.vue?vue&type=template&id=262aab34&scoped=true"
import script from "./ViSchoolList.vue?vue&type=script&lang=js"
export * from "./ViSchoolList.vue?vue&type=script&lang=js"
import style0 from "./ViSchoolList.vue?vue&type=style&index=0&id=262aab34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262aab34",
  null
  
)

export default component.exports